import { __rest } from "tslib";
import { apiHolder, getIn18Text, api, apis } from 'api';
import React, { useState, useEffect, useRef } from 'react';
import { message } from 'antd';
const systemApi = apiHolder.api.getSystemApi();
const trackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
const roleApi = api.requireLogicalApi(apis.edmRoleApiImpl);
const isElectron = systemApi.isElectron();
const QI_YU_CONFIG = isElectron
    ? { referrer: 'https://khd.waimao.office.163.com/khd', title: getIn18Text('WAIMAOTONGKEHUDUAN') }
    : { referrer: 'https://wangye.website.waimao.office.163.com/wangye', title: getIn18Text('WAIMAOTONGWANGYEDUAN') };
export const WmKfEntry = props => {
    const { className, style, children, onClick } = props, restProps = __rest(props, ["className", "style", "children", "onClick"]);
    const onClickFromProps = onClick || (() => { });
    const qiyuLoading = useRef(false);
    const [orgConf, setOrgConf] = useState({
        orgId: '',
        corpId: 0,
        corpName: '',
        domain: '',
    });
    const handleKfScriptLoad = () => new Promise((resolve, reject) => {
        if (window.ysf)
            return resolve();
        if (qiyuLoading.current)
            return reject();
        const user = systemApi.getCurrentUser();
        qiyuLoading.current = true;
        const script = document.createElement('script');
        script.src = 'https://qiyukf.com/script/abab5b9989e6f898240067f40874a096.js?hidden=1';
        script.onload = () => {
            var _a;
            qiyuLoading.current = false;
            if (window.ysf) {
                const uid = ((_a = user === null || user === void 0 ? void 0 : user.contact) === null || _a === void 0 ? void 0 : _a.contact.id) || undefined;
                const name = (user === null || user === void 0 ? void 0 : user.id) || (user === null || user === void 0 ? void 0 : user.nickName);
                window.ysf('config', {
                    uid,
                    name,
                    robotId: 5390874,
                    referrer: QI_YU_CONFIG.referrer,
                    title: QI_YU_CONFIG.title,
                    robotShuntSwitch: 1,
                    groupid: 482281247,
                    templateId: 6666111,
                    qtype: 4491460,
                    hidden: 1,
                });
                resolve();
            }
            else {
                reject();
            }
        };
        script.onerror = () => {
            qiyuLoading.current = false;
            reject();
        };
        document.body.appendChild(script);
    });
    const handleKf = () => {
        var _a;
        trackApi.track(process.env.BUILD_ISELECTRON ? 'client_customer_service' : 'web_customer_service');
        const user = systemApi.getCurrentUser();
        const uid = ((_a = user === null || user === void 0 ? void 0 : user.contact) === null || _a === void 0 ? void 0 : _a.contact.id) || undefined;
        const name = (user === null || user === void 0 ? void 0 : user.id) || (user === null || user === void 0 ? void 0 : user.nickName) || getIn18Text('WANGYISHOUHOUGOUTONGX') + orgConf.corpId + orgConf.corpName + orgConf.domain;
        window.ysf('config', {
            uid,
            robotId: 5390874,
            referrer: QI_YU_CONFIG.referrer,
            name: name || '网易售后沟通X3941499网易外贸测试waimao.elysys.net',
            title: QI_YU_CONFIG.title,
            robotShuntSwitch: 1,
            groupid: 482281247,
            success: function () {
                console.log('succ');
                window === null || window === void 0 ? void 0 : window.ysf('open', {
                    templateId: 6666111,
                });
            },
            error: function (err) {
                message.error(err);
                console.log(err);
            },
            templateId: 6666111,
            qtype: 4491460,
            hidden: 1,
        });
    };
    const handleClick = () => {
        trackApi.track('waimao_customer_service', { action: 'click' });
        handleKfScriptLoad().then(() => {
            handleKf();
        });
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            handleKfScriptLoad();
        }, 30000);
        return () => timer && clearTimeout(timer);
    }, []);
    useEffect(() => {
        roleApi.getKfInfo().then(data => {
            setOrgConf(data);
        });
    }, []);
    return (React.createElement("div", Object.assign({ className: className, style: style, onClick: event => {
            handleClick();
            onClickFromProps(event);
        } }, restProps), children));
};
